import { useEffect } from 'react'

import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'

import dayjs from 'dayjs'
import { RefreshDataOptions, useRefreshData } from './useRefreshData'

export const useRefreshCharacterDetails = (
  character: wowaudit.CharacterReference | undefined,
  options: RefreshDataOptions,
) => {
  const { t } = useTranslation()
  const { refreshing, refreshData, updateTriggeredAt } = useRefreshData(options)

  useEffect(() => {
    if (updateTriggeredAt && character?.refreshFailedAt) {
      if (dayjs(updateTriggeredAt).isBefore(dayjs(character.refreshFailedAt))) {
        toast.error(
          t(`errors.character_update_error`, {
            code: character.lastStatusCode,
          }),
        )
      }
    }
  }, [character?.refreshFailedAt])

  return { refreshing, refreshData, updateTriggeredAt }
}
